import Certification from "@/views/MGT/MyEnterprise/modal/Certification";
import UpdateUnitName from "@/views/MGT/MyEnterprise/modal/UpdateUnitName";
import UpdateUnitAddress from "@/views/MGT/MyEnterprise/modal/UpdateUnitAddress";
import UpdateUnitPhone from "@/views/MGT/MyEnterprise/modal/UpdateUnitPhone";
import UpdateUnitWebsite from "@/views/MGT/MyEnterprise/modal/UpdateUnitWebsite";
import PreviewImg from "./modal/PreiviewImg.vue";
import { getUnitInfo, updateUnitInfo } from "@/service/unit";
import { dictList } from "@/service/user";
import UploadCutter from "@/components/Upload/UploadCutter";
import axios from "axios";
export default {
  name: "Enterprise",
  components: {
    Certification,
    UploadCutter,
    UpdateUnitName,
    UpdateUnitAddress,
    UpdateUnitPhone,
    UpdateUnitWebsite,
    PreviewImg
  },
  data() {
    return {
      unit: {
        logoUrl: ""
      },
      file: {
        url: ""
      },
      certification: {
        visible: false
      },
      updateUnitName: {
        visible: false
      },
      updateUnitAddress: {
        visible: false
      },
      updateUnitPhone: {
        visible: false
      },
      updateUnitWebsite: {
        visible: false
      },
      typeList: [],
      preview: {
        visible: false
      }
    };
  },
  computed: {
    unitType() {
      let value = "";
      let index = this.typeList.findIndex(v => v.code === this.unit.type);
      if (index > -1) {
        value = this.typeList[index].value;
      } else {
        value = $t("eae82", "其他");
      }
      return value;
    },
    _unitId() {
      return this.$store.state.user.userInfo.unitId;
    }
  },
  methods: {
    openModal(key) {
      switch (key) {
        case "editName":
          this.updateUnitName.visible = true;
          break;
        case "addAddress":
          this.updateUnitAddress.visible = true;
          break;
        case "phone":
          this.updateUnitPhone.visible = true;
          break;
        case "website":
          this.updateUnitWebsite.visible = true;
          break;
        case "certification":
          this.certification.visible = true;
          break;
        case "showImg":
          this.preview.visible = true;
          break;
        default:
          break;
      }
    },
    onChangeFile(fileValue) {
      this.file.url = fileValue.dataURL;
      this.uploadImg(fileValue);
    },
    async uploadImg(fileValue) {
      console.log(fileValue);
      let form = new FormData();
      form.append("files", fileValue.file);
      axios.post("/api/file/upload", form, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        if (res.data && res.data.result == 0) {
          this.updateUnitMessage(res.data.retVal);
        }
      }, err => {
        console.log(err);
      });
    },
    async getUnitMessage() {
      let parmas = {
        unitId: this.$route.query.unitId || this._unitId
      };
      let res = await getUnitInfo(parmas);
      if (res.data && res.data.result == 0) {
        this.unit = res.data.retVal;
        this.file.url = this.unit.logo;
      }
    },
    async updateUnitMessage(url) {
      let parmas = {
        logo: url
      };
      let res = await updateUnitInfo(parmas);
      if (res.data && res.data.result == 0) {
        this.$Message.success($t("a6esth4", "上传成功"));
      }
    },
    async getDictList() {
      let parmas = {
        category: "UNIT_TYPE"
      };
      let res = await dictList(parmas);
      if (res.data && res.data.result == 0) {
        this.typeList = res.data.retVal;
      }
    }
  },
  async mounted() {
    await this.getDictList();
    this.getUnitMessage();
  }
};